// extracted by mini-css-extract-plugin
module.exports = {"mCard":"ae","image":"be","imageNoBackground":"ce"};